import React, { ReactElement } from 'react';
import { cn } from 'utils';
import { JobsiteInfo } from 'containers/jobsite/tabs/jobsiteInfo/types';
import {
  useWorkerOnboardingLink,
  WorkerOnboardingLink,
} from 'components/workerOnboardingLink';

export type JobsiteSelfOnboardingCardProps = {
  jobsite?: JobsiteInfo;
};

export function JobsiteSelfOnboardingCard({
  jobsite,
}: JobsiteSelfOnboardingCardProps): ReactElement {
  const { name: jobsiteName, defaultJobsiteContractor } = jobsite ?? {};
  const {
    id: defaultJobsiteContractorId,
    contractor: defaultContractor,
    jobsiteInvitation: defaultInvitation,
  } = defaultJobsiteContractor ?? {};
  const defaultJobsiteInvitationId = defaultInvitation?.jobsiteInvitationId;
  const defaultContractorName = defaultContractor?.organization?.name;

  const [newJobsiteInvitationId, setNewJobsiteInvitationId] = React.useState<
    string | null
  >(null);

  const {
    onboardingLink,
    canGenerateOnboardingLink,
    generateOnboardingLink,
    isGeneratingOnboardingLink,
  } = useWorkerOnboardingLink({
    jobsiteInvitationId: newJobsiteInvitationId ?? defaultJobsiteInvitationId,
    jobsiteContractorId: defaultJobsiteContractorId,
    onJobsiteInvitationCreated: (jobsiteInvitationId) => {
      setNewJobsiteInvitationId(jobsiteInvitationId);
    },
  });

  return (
    <div
      className={cn(
        'odin-flex odin-flex-col odin-gap-5',
        'odin-rounded-2xl odin-border odin-border-odin-medium-gray',
        'odin-bg-odin-white odin-p-6',
      )}
    >
      <span className="odin-text-sm odin-text-odin-navy">
        Worker onboarding
      </span>
      <WorkerOnboardingLink
        onboardingLink={onboardingLink}
        canGenerateOnboardingLink={canGenerateOnboardingLink}
        generateOnboardingLink={generateOnboardingLink}
        isGeneratingOnboardingLink={isGeneratingOnboardingLink}
        contractorName={defaultContractorName ?? ''}
        jobsiteName={jobsiteName ?? ''}
      />
    </div>
  );
}
